import { ILocationsState } from './locations.state';
import { createReducer, on } from '@ngrx/store';
import {
  createLocationSurveyPoint,
  createLocationSurveyPointFailure,
  createLocationSurveyPointSuccess,
  loadLocationById,
  loadLocationByIdFailure,
  loadLocationByIdSuccess,
  loadLocations,
  loadLocationsFailure,
  loadLocationsSuccess,
  loadLocationSurveyPoints,
  loadLocationSurveyPointsFailure,
  loadLocationSurveyPointsSuccess,
  searchSurveyPoints,
  searchSurveyPointsFailure,
  searchSurveyPointsSuccess,
  setLocationSurveyPointsInactive,
  setLocationSurveyPointsInactiveSuccess,
  updateLocationCountries,
  updateLocationCountriesFailure,
  updateLocationCountriesSuccess,
} from './locations.actions';

export const initialState: ILocationsState = {
  locations: [],
  location: undefined,
  surveyPoints: [],
  searchedSurveyPoints: [],
  loading: false,
  buttonLoading: false,
};

export const locationsReducer = createReducer(
  initialState,
  on(loadLocations, (state) => ({ ...state, loading: true })),
  on(loadLocationsSuccess, (state, { locations }) => ({
    ...state,
    locations,
    loading: false,
  })),
  on(loadLocationsFailure, (state) => ({ ...state, loading: false })),
  on(loadLocationById, (state) => {
    return { ...state, loading: true };
  }),
  on(loadLocationByIdSuccess, (state, { location }) => {
    return {
      ...state,
      location: { ...location },
      loading: false,
    };
  }),
  on(loadLocationByIdFailure, (state) => ({ ...state, loading: false })),
  on(loadLocationSurveyPoints, (state) => ({ ...state, loading: true })),
  on(loadLocationSurveyPointsSuccess, (state, { surveyPoints }) => ({
    ...state,
    surveyPoints,
    loading: false,
  })),
  on(loadLocationSurveyPointsFailure, (state) => ({
    ...state,
    loading: false,
  })),
  on(updateLocationCountries, (state) => ({ ...state, loading: true })),
  on(updateLocationCountriesSuccess, (state) => {
    return { ...state, loading: false };
  }),
  on(updateLocationCountriesFailure, (state) => ({ ...state, loading: false })),
  on(createLocationSurveyPoint, (state) => ({ ...state, loading: true })),
  on(createLocationSurveyPointSuccess, (state, { surveyPoint }) => {
    return { ...state, surveyPoint, loading: false };
  }),
  on(createLocationSurveyPointFailure, (state) => ({
    ...state,
    loading: false,
  })),
  on(setLocationSurveyPointsInactive, (state) => ({
    ...state,
    buttonLoading: true,
  })),
  on(setLocationSurveyPointsInactiveSuccess, (state) => ({
    ...state,
    buttonLoading: false,
  })),
  on(searchSurveyPoints, (state) => ({
    ...state,
    loading: true,
  })),
  on(searchSurveyPointsSuccess, (state, { searchedSurveyPoints }) => {
    return {
      ...state,
      searchedSurveyPoints,
      loading: false,
    };
  }),
  on(searchSurveyPointsFailure, (state, { error }) => {
    return {
      ...state,
      loading: false,
      error,
    };
  })
);
